module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 148);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor");

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.parse-int");

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/account-print/src/main.vue?vue&type=template&id=00d31e0a&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-print" }, [
    _c("div", { staticClass: "noprint print-panel" }, [
      _c("div", { staticClass: "c-6 f-13" }, [
        _c("span", { staticClass: "label-width" }, [_vm._v("总回单数：")]),
        _c("span", { staticClass: "c-3 f-13 fw-b" }, [
          _vm._v(_vm._s(_vm.total))
        ])
      ]),
      _c("div", { staticClass: "c-6 f-13 m-t12" }, [
        _c("span", { staticClass: "label-width" }, [_vm._v("总页数：")]),
        _c("span", { staticClass: "c-3 f-13 fw-b" }, [
          _vm._v(_vm._s(_vm.totalPage))
        ])
      ]),
      _c("div", { staticClass: "c-6 f-13 m-t12" }, [
        _c("span", { staticClass: "label-width" }, [_vm._v("当前页：")]),
        _c("span", { staticClass: "c-3 f-13 fw-b" }, [
          _vm._v(_vm._s(_vm.pageNo))
        ])
      ]),
      _c(
        "div",
        { staticClass: "text-center m-t20" },
        [
          _c("el-pagination", {
            attrs: {
              small: "",
              background: "",
              layout: "prev, pager, next",
              "pager-count": 5,
              total: _vm.total,
              "page-size": _vm.pageSize,
              "current-page": _vm.pageNo,
              "hide-on-single-page": true
            },
            on: { "current-change": _vm.handleNoChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-center m-t20" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "primary",
                disabled:
                  _vm.images.length === 0 ||
                  _vm.completeCount + _vm.errorCount !== _vm.images.length
              },
              on: { click: _vm.handlePrint }
            },
            [_vm._v("\n        打印\n      ")]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "print-receipt" },
      _vm._l(_vm.images, function(url, index) {
        return _c("img", {
          key: index,
          staticClass: "print-receipt-img",
          attrs: { src: url, alt: "" },
          on: { load: _vm.handlerLoad, error: _vm.handleError }
        })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/account-print/src/main.vue?vue&type=template&id=00d31e0a&

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each"
var es_array_for_each_ = __webpack_require__(8);

// EXTERNAL MODULE: external "core-js/modules/es.array.slice"
var es_array_slice_ = __webpack_require__(17);

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor"
var es_number_constructor_ = __webpack_require__(10);

// EXTERNAL MODULE: external "core-js/modules/es.number.parse-int"
var es_number_parse_int_ = __webpack_require__(100);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each"
var web_dom_collections_for_each_ = __webpack_require__(9);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/account-print/src/main.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_PAGE_SIZE = 200;
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'AccountPrint',
  data: function data() {
    return {
      images: [],
      completeCount: 0,
      errorCount: 0,
      total: 0,
      totalPage: 0,
      pageNo: 1,
      pageSize: MAX_PAGE_SIZE,
      loadingInstance: null
    };
  },
  mounted: function mounted() {
    this.resetCss();
    this.fetch();
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$$route$query, accId, startTime, endTime, accQuery, resp, _this$$zgKaihu$$conve, success, data, images, pageData, i, startIndex, endIndex, _data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //校验参数
                _this$$route$query = _this.$route.query, accId = _this$$route$query.accId, startTime = _this$$route$query.startTime, endTime = _this$$route$query.endTime;

                if (!(!accId || !startTime || !endTime)) {
                  _context.next = 4;
                  break;
                }

                _this.$message.error('参数缺失');

                return _context.abrupt("return");

              case 4:
                accQuery = {
                  accId: accId,
                  startTime: "".concat(startTime, " 00:00:00"),
                  endTime: "".concat(endTime, " 23:59:59"),
                  pageNo: 1,
                  pageSize: 9999,
                  pageData: {}
                };
                _context.prev = 5;
                _context.next = 8;
                return _this.$zgKaihu.$post('paycore.listAccFlow', {
                  accQuery: accQuery
                });

              case 8:
                resp = _context.sent;
                _this$$zgKaihu$$conve = _this.$zgKaihu.$convertResp(resp), success = _this$$zgKaihu$$conve.success, data = _this$$zgKaihu$$conve.data;

                if (success) {
                  if (data && data.accFlows && data.accFlows.length > 0) {
                    images = [];
                    data.accFlows.forEach(function (ele) {
                      if (ele.bankReceipt) {
                        images.push(_this.$zgKaihu.$convertFile(ele.bankReceipt));
                      }
                    });

                    if (images.length === 0) {
                      _this.$message.warning('未查询到交易回单');
                    } else {
                      _this.total = images.length;
                      _this.pageNo = 1;
                      _this.totalPage = _this.total % _this.pageSize ? Number.parseInt(_this.total / _this.pageSize) + 1 : Number.parseInt(_this.total / _this.pageSize); //数据进行分页

                      pageData = {};

                      for (i = 1; i <= _this.totalPage; i++) {
                        startIndex = (i - 1) * _this.pageSize;
                        endIndex = startIndex + _this.pageSize;
                        _data = images.slice(startIndex, endIndex);
                        pageData[String(i)] = _data;
                      }

                      _this.pageData = pageData;
                      _this.completeCount = 0;
                      _this.errorCount = 0;
                      _this.images = _this.pageData[String(_this.pageNo)];

                      _this.showLoading();
                    }
                  } else {
                    _this.$message.warning('未查询到交易记录');
                  }
                }

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](5);
                console.log(_context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 13]]);
      }))();
    },
    handleNoChange: function handleNoChange(pageNo) {
      this.pageNo = pageNo;
      this.completeCount = 0;
      this.errorCount = 0;
      this.images = this.pageData[String(this.pageNo)];
      this.showLoading();
    },
    handlePrint: function handlePrint() {
      setTimeout(function () {
        window.print();
      }, 0); // setTimeout(()=>{
      // window.print()
      // if(!this.isSafari()){
      //   window.close()
      // }
      // },0)
    },
    handlerLoad: function handlerLoad() {
      this.completeCount = this.completeCount + 1;

      if (this.completeCount + this.errorCount === this.images.length) {
        this.closeLoading();
      }
    },
    handleError: function handleError() {
      this.errorCount = this.errorCount + 1;

      if (this.completeCount + this.errorCount === this.images.length) {
        this.closeLoading();
      }
    },
    showLoading: function showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    closeLoading: function closeLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    resetCss: function resetCss() {
      var style = window.document.createElement('style');
      style.type = 'text/css';
      var cssNode = document.createTextNode('@page { margin: 0; }');
      style.appendChild(cssNode);
      document.getElementsByTagName('HEAD')[0].appendChild(style);
    },
    isSafari: function isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    }
  }
});
// CONCATENATED MODULE: ./packages/account-print/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/account-print/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/account-print/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/account-print/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var account_print = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.slice");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each");

/***/ })

/******/ });